import { render, staticRenderFns } from "./MarketModal.vue?vue&type=template&id=0bd89c17"
import script from "./MarketModal.vue?vue&type=script&lang=ts"
export * from "./MarketModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports